export const mtMergeReleaseEnabled = (
  environment: Readonly<Record<string, string | undefined>> = process.env,
): boolean => environment.REACT_APP_RELEASE_INCLUDES_MT_MERGE === 'true'
